import { service } from '@ember/service';
import Route from '@ember/routing/route';

export default class SiteBillingTransferRoute extends Route {
  @service billingTransfer;
  @service router;

  async beforeModel(transition) {
    let { clientId, channelName } = transition.to.queryParams;

    this.billingTransfer.resetBillingTransferSession(transition);

    if (!(await this.billingTransfer.load({ clientId, channelName }))) {
      await this.billingTransfer.loadAfterBillingModel({ to: { name: 'site.billing.index' } });
      this.router.replaceWith('site.billing.index');
      return;
    }

    if (!this.billingTransfer.isTargetClientCurrentClient) {
      return this.#retryAfterSwitch(transition);
    }

    this.#finishTransfer();
  }

  async #retryAfterSwitch(transition) {
    let switched = await this.billingTransfer.switchToTargetClient();

    if (switched && this.billingTransfer.takeClientSwitchRetry()) {
      return transition.retry();
    }

    void this.router.replaceWith('site.billing.index');
  }

  #finishTransfer() {
    if (this.billingTransfer.isPendingTransfer) {
      this.billingTransfer.openModal({ force: true });
    }

    this.router.replaceWith('site.billing.index');
  }
}
